import React from "react";

//redux
import { useSelector, connect, useDispatch } from "react-redux";

//sweet alert
import { alert, warning, permissionError } from "../util/Alert";

//action
import { deleteGift } from "../store/gift/action";

// type
import { OPEN_GIFT_DIALOG } from "../store/gift/types";

//routing
import { useHistory } from "react-router-dom";

//image
import noImage from "../assets/images/noImage.png";

import Chip from "@material-ui/core/Chip";

const AllGift = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const hasPermission = useSelector((state) => state.admin.admin.flag);

  const handleDelete = (giftId) => {
    const data = warning();
    data
      .then((isDeleted) => {
        if (isDeleted) {
          if (!hasPermission) return permissionError();
          props.deleteGift(giftId);
          alert("Deleted!", `Gift has been deleted!`, "success");
        }
      })
      .catch((err) => console.log(err));
  };

  const handleEdit = (data) => {
    dispatch({ type: OPEN_GIFT_DIALOG, payload: data });
  };
  return (
    <>
      {props.data?.gift?.length > 0 ? (
        props.data?.gift?.map((data, index) => {
          return (
            <>
              <div
                className="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-4"
                key={index}
                onClick={() => {
                  localStorage.setItem("CategoryId", data._id);
                  history.push("/admin/giftCategory/gift");
                }}
              >
                <div className="card contact-card card-bg">
                  <div className="card-body p-1">
                    <div className="row px-3 py-4 ">
                      <div className="col-4 ps-4">
                        <img
                          src={
                            data.type === 2 && data.imagePreview
                              ? data.imagePreview
                              : data.image
                                ? data.image
                                : noImage
                          }
                          alt=""
                          className="rounded-circle"
                          style={{
                            width: "135px",
                            height: "135px",
                            objectFit: "cover",
                          }}
                          draggable="false"
                        />
                        <div className="mt-2 mb-3">
                          {data?.showInStore ? (
                            <Chip
                              size="small"
                              label="In user store"
                              color="secondary"
                            />
                          ) : (
                            <Chip
                              size="small"
                              label="Not in user store"
                              color="primary"
                            />
                          )}
                        </div>
                      </div>
                      <div
                        className="col-8 text-end pe-4"
                        style={{
                          padding: 0,
                          paddingLeft: 5,
                        }}
                      >
                        <div className="contact-card-info mt-2 mb-5 px-3">
                          <h3 className="text-white">Diamond: {data.coin}</h3>
                        </div>
                        <div className="px-3">
                          <i
                            className="fas fa-edit text-white p-2 bg-primary rounded-circle"
                            style={{ marginRight: 10, fontSize: 25 }}
                            onClick={() => handleEdit(data)}
                          ></i>

                          <i
                            className="fas fa-trash text-white p-2 bg-danger rounded-circle"
                            style={{ marginRight: 10, fontSize: 25 }}
                            onClick={() => handleDelete(data._id)}
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        })
      ) : (
        <tr>
          <td colSpan="6" align="center">
            Nothing to show!!
          </td>
        </tr>
      )}
    </>
  );
};

export default connect(null, { deleteGift })(AllGift);
